import { Formik, Form } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { SimpleFormControl } from "src/app/components/form/SimpleFormControl";
import { StripeTransport } from "src/app/transports/stripe";
import { object, number } from "yup";

export interface IGenerateLinkModalContainer {
    handleClose(): void;
    showModal: boolean;
}
const GenerateLinkModalContainer = (props: IGenerateLinkModalContainer) => {
    const { handleClose, showModal } = props;
    const { formatMessage } = useIntl();
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState();

    const onSubmit = async (_values: { price: number }) => {
        setLoading(true);
        try {
            const response = await StripeTransport.getPaymentLink(_values.price);
            setUrl(response.message);
            toast.success(formatMessage({ id: "common.notification.success" }));
        } catch (error: any) {
            toast.error(
                error?.response?.data?.errors[0]?.message ||
                    formatMessage({ id: "common.notification.error" })
            );
        } finally {
            setLoading(false);
        }
    };
    return (
        <SimpleModal
            entityName="PaymentLink"
            showModal={showModal}
            handleClose={handleClose}
            formId="generatePaymentLink"
            buttonConfirmationLabel="ok"
            leftButtons={
                url
                    ? [
                          {
                              label: "return",
                              onClick: () => setUrl(undefined),
                              variant: "secondary",
                              type: "button",
                          },
                      ]
                    : []
            }
            loading={loading}
            modalProps={{ size: "lg" }}
        >
            <>
                {!url ? (
                    <Formik
                        initialValues={{ price: 0 }}
                        validationSchema={object().shape({
                            price: number().required(),
                        })}
                        onSubmit={onSubmit}
                    >
                        <Form id="generatePaymentLink">
                            <SimpleFormControl
                                label={formatMessage({ id: "common.field.price" })}
                                type="number"
                                min={0.0}
                                step=".01"
                                name="price"
                            />
                        </Form>
                    </Formik>
                ) : (
                    <a href={url} target="_blank">
                        {url}
                    </a>
                )}
            </>
        </SimpleModal>
    );
};

export default GenerateLinkModalContainer;
